class Badge
    constructor: (el) ->
        @.$el = el
        
        @.value = parseInt(@.$el.dataset.value,10) ? 1
        @.withdraw = @.$el.classList.contains 'badge--withdraw'

        @.InitEvents()
        @.$el.classList.add 'badge--bound'
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'badge-set-value', (e) ->
            value = e.detail?.value ? false
            value = if value then parseInt(value,10) else false
            if value
                self.SetValue value
            return
        @.$el.addEventListener 'badge-set-withdraw', (e) ->
            withdraw = e.detail?.withdraw ? null
            if withdraw != null
                self.SetWithdraw withdraw
            return
        @.$el.addEventListener 'badge-toggle-withdraw', (e) ->
            self.SetWithdraw !self.withdraw
            return
        return

    SetWithdraw: (withdraw) ->
        if withdraw
            @.$el.classList.add 'badge--withdraw'
            @.withdraw = true
        else
            @.$el.classList.remove 'badge--withdraw'
            @.withdraw = false
        return
    
    SetValue: (value) ->
        @.value = parseInt(value,10)
        @.$el.dataset.value = @.value
        @.$el.textContent = @.value
        return

BindBadges = ->
    document.querySelectorAll '.badge:not(.badge--bound)'
        .forEach (el) ->
            new Badge el
            return

window.addEventListener 'bind-components', BindBadges